import { type SVGAttributes } from "react";

export function UserIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="7.7934"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6 18.6768C6 15.3795 8.70278 12.7066 12 12.7066V12.7066C15.2972 12.7066 18 15.3795 18 18.6768V18.6768C18 18.6932 17.9866 18.7066 17.9701 18.7066H6.02985C6.01337 18.7066 6 18.6932 6 18.6768V18.6768Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
